module.exports = __webpack_public_path__ + "static/media/RobotoMono-Thin.b93c2ad4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Fonts/RobotoMono-Thin.ttf
// module id = 110
// module chunks = 0